export enum Layers
{
    boss,
    bgbees,
    playerFalling,
    hexagons,
    pickup,
    tower,
    player,
    playerGround,
    towerAttack,
    bossAttack,
    gameStatus,
}
